<section class="widget-container">
	<div echarts [options]="echartOptions"></div>
</section>
